import { render } from "./SystemLoginView.vue?vue&type=template&id=f7bf7b6a&scoped=true&ts=true"
import script from "./SystemLoginView.vue?vue&type=script&lang=ts"
export * from "./SystemLoginView.vue?vue&type=script&lang=ts"

import "./SystemLoginView.vue?vue&type=style&index=0&id=f7bf7b6a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7bf7b6a"]])

export default __exports__